import type { TeamCoursePreview } from "@/api";

export const PENDING_COURSE_LS_KEY = "studentOnboarding.pendingCourse";

export const PENDING_COURSE_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

export type PendingCourse = { courseUid: string; schoolUid: string; rememberedAt: number };

export function readPendingCourse(): PendingCourse | null {
  try {
    const stored = JSON.parse(
      localStorage.getItem(PENDING_COURSE_LS_KEY) ?? "null",
    ) as PendingCourse | null;
    if (!stored) return null;

    if (Date.now() - stored.rememberedAt < PENDING_COURSE_TTL_MS) return stored;

    forgetPendingCourse();
    return null;
  } catch {
    return null;
  }
}

export function rememberPendingCourse(course: Pick<TeamCoursePreview, "uid" | "schoolUid">): void {
  const record: PendingCourse = {
    courseUid: course.uid,
    schoolUid: course.schoolUid,
    rememberedAt: Date.now(),
  };
  localStorage.setItem(PENDING_COURSE_LS_KEY, JSON.stringify(record));
}

export function forgetPendingCourse(): void {
  localStorage.removeItem(PENDING_COURSE_LS_KEY);
}
